export const globalViewerId = { id: 0 }
